import React from "react";
import { useOutletContext } from "react-router-dom";
import DeepSearchChatInterface from "../components/chat/DeepSearchChatInterface";

function DeepSearch() {
  const { isMobile, sidebarOpen, chats, setChats } = useOutletContext();

  return (
    <DeepSearchChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setChats}
      chats={chats}
    />
  );
}

export default DeepSearch;
